export default __webpack_public_path__ + "static/media/P5000.2096e2fb.jpg";